export default __webpack_public_path__ + "static/hero-supervision-93625bb487042394537b0ca80f18cba0.jpg";